<template>
    <div>
        <base-spinner v-if="isLoading"/>
        <base-page v-else>
            <b-row class="justify-content-center">
                <b-col cols="8" class="bg-white">
                    <b-row class="justify-content-end mr-3 my-3">
                        <b-link @click="$bvModal.show('cancel-dialog')"> {{ $t('utils.cancel') }} </b-link>
                    </b-row>

                    <component
                        :is="componentList[current]"
                        ref="child"
                        class="mx-3"
                    >
                        <template v-slot:title>
                            <h2 class="text-center text-secondary">{{ $t('surgery.finalEvaluation') }}</h2>
                        </template>
                    </component>

                    <general-error :error="error"/>

                    <step-navigation
                        :steps="componentList.length"
                        :should-go-next="next"
                        :should-go-back="back"
                        :save="save"
                        @current="componentChanged"
                    />
                </b-col>
            </b-row>

            <exit-confirm-dialog
                :back-route="backRouteParams"
                modal-id="cancel-dialog"
            />
        </base-page>
    </div>
</template>

<script>
    import {mapActions, mapState} from "vuex";
    import StepNavigation from "@/components/StepNavigation";
    import FinalEvaluationData from "@/components/finalevaluation/FinalEvaluationData";
    import {cloneDeep} from "lodash";
    import FinalEvaluationTreatments from "@/components/finalevaluation/FinalEvaluationTreatments";
    import FinalEvaluationReadmissions from "@/components/finalevaluation/FinalEvaluationReadmissions";
    import FinalEvaluationOutpatient from "@/components/finalevaluation/FinalEvaluationOutpatient";
    import GeneralError from "@/components/GeneralError";
    import ExitConfirmDialog from "@/components/ExitConfirmDialog";
    import BasePage from "@/components/BasePage";
    import BasePageMixin from "@/components/BasePageMixin";
    import BaseSpinner from "@/components/BaseSpinner";
    import {logRequestError} from "@/utils/utils";

    export default {
        name: "SurgeryFinalEvaluationPage",
        components: {BaseSpinner, BasePage, ExitConfirmDialog, GeneralError, StepNavigation},
        mixins: [BasePageMixin],
        props: {
            surgeryId: {
                type: Number,
                required: true,
            },
        },
        data() {
            return {
                componentList: [
                    FinalEvaluationData,
                    FinalEvaluationTreatments,
                    FinalEvaluationReadmissions,
                    FinalEvaluationOutpatient,
                ],
                current: 0,
                error: false,
            };
        },
        computed: {
            ...mapState([
                'surgery',
                'surgeryFields',
                'finalEvaluation',
                'finalEvaluationFields',
            ]),
            subtitle() {
                return this.$refs.child.title || '';
            },
            backRouteParams() {
                return { name: 'surgery-detail', params: {surgeryId: this.surgeryId} };
            }
        },
        async created() {
            await this.getSurgery(this.surgeryId);
            await this.getSurgeryOptions();
            await this.getFinalEvaluationOptions();
            this.setFinalEvaluation(cloneDeep(this.surgery.final_evaluation));
            this.isLoading = false;
        },
        methods: {
            ...mapActions([
                'getSurgery',
                'getSurgeryOptions',
                'setFinalEvaluation',
                'updateFinalEvaluation',
                'getFinalEvaluationOptions',
            ]),
            async next() {
                return await this.$refs.child.validate();
            },
            async back() {
                await this.$refs.child.back();
                return true;
            },
            async save() {
                this.error = false;
                if (await this.$refs.child.validate()) {
                    this.updateFinalEvaluation({pk: this.finalEvaluation.id, data: this.finalEvaluation})
                        .then(() => {
                            this.$router.push(this.backRouteParams);
                        })
                        .catch(error => {
                            logRequestError(error);
                            this.error = true;
                        });
                }
            },
            componentChanged(index) {
                this.current = index;
            }
        }
    };
</script>

